<template>
<div id="content">
	<div class="center">
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li>基本情報</li>
			<li>連絡先</li>
			<li>その他</li>
			<li class="selected">内容確認</li>
		</ul>
	</div>
<!-- 内容 -->
	<div id="mosikomi" class="content-blk">
			<!-- ステップ4：確認 -->
		<div class="inner">
			<!-- クラスは仮でつけた -->
			<p>以下の内容で登録してよろしいですか？</p>
			<table class="table_confirm">
				<tr>
					<td width="38%">ログインID</td>
					<td v-if="katudo.id" width="62%">{{ katudo.id }}</td>
					<td v-else width="62%" class="warn_red">未入力</td>
				</tr>
				<tr>
					<td>パスワード</td>
					<td v-if="katudo.password">{{katudo.password}}</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr>
					<td>氏名</td>
					<td v-if="katudo.name">{{ katudo.name }}</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr>
					<td>ふりがな</td>
					<td v-if="katudo.kana">{{ katudo.kana }}</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr>
					<td>性別</td>
					<td v-if="katudo.sex === '2'">男性</td>
					<td v-else-if="katudo.sex === '1'">女性</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr>
					<td>生年月日</td>
					<td v-if="katudo.birthday">{{ katudo.birthday }}</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr>
					<td>郵便番号</td>
					<td v-if="katudo.zipcode1 && katudo.zipcode2">〒{{ katudo.zipcode1 }}-{{ katudo.zipcode2 }}</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr>
					<td>住所</td>
					<td v-if="katudo.address">{{ katudo.address }}</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr>
					<td>電話番号</td>
					<td v-if="katudo.tel">{{ katudo.tel }}</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr v-if="katudo.phone">
					<td>携帯電話番号</td>
					<td>{{ katudo.phone }}</td>
				</tr>
				<tr v-if="katudo.fax">
					<td>FAX番号</td>
					<td>{{ katudo.fax }}</td>
				</tr>
				<tr v-if="katudo.mail">
					<td>メールアドレス</td>
					<td>{{ katudo.mail }}</td>
				</tr>
				<tr>
					<td>職業</td>
					<td v-if="katudo.job === '1'">社会人</td><td v-else-if="katudo.job === '2'">主婦/主夫</td><td v-else-if="katudo.job === '3'">学生</td><td v-else-if="katudo.job === '4'">フリーター</td><td v-else-if="katudo.job === '5'">無職</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr v-if="(katudo.job === '1') || (katudo.job === '3') || (katudo.job === '4')">
					<td>勤務先・学校名</td>
					<td v-if="katudo.company">{{ katudo.company }}</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
				<tr>
					<td>ボランティア活動経験</td>
					<td v-if="katudo.keiken === '1'">有り</td>
					<td v-else-if="katudo.keiken === '2'">無し</td>
					<td v-else class="warn_red">未入力</td>
				</tr>
			</table>
		</div>

		<div class="center">
			<router-link to="/katudo-touroku/step3"><button class="btn_cancel">戻る</button></router-link>
			<button @click="onSubmit" class="btn_on">登録</button>
		</div>

	</div>
</div>
</template>

<script>
// 状態管理
import { inject } from 'vue';
// import router from '../router';
export default {
	name: 'KatsudoTouroku5',
	components: {
	},
	setup(){
		const { katudo, birthtoDay, register } = inject('ktouroku');
		return {
			katudo,
			birthtoDay,
			register,
		};
	},
	data() {
		return {
			// katudo: {},
		};
	},
	async created(){
		this.birthtoDay();
	},
	methods: {
		onSubmit() {
			if (this.katudo.id && this.katudo.password && this.katudo.name && this.katudo.kana && this.katudo.sex && this.katudo.birth && this.katudo.zipcode1 && this.katudo.zipcode2 && this.katudo.address && this.katudo.tel && this.katudo.job && this.katudo.keiken) {
				// 登録処理
				this.register();
			} else {
				alert('必須項目が入力されていません。\n戻って再入力してください。')
			}
		},
	},
}
</script>
